import { Component, OnInit, Input, ElementRef, OnDestroy } from '@angular/core';
import { BehaviorSubject , of } from 'rxjs';

@Component({
  selector: 'app-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
})
export class CustomSnackbarComponent implements OnInit, OnDestroy {

  @Input() content: String;
  @Input() options: any;
  close: boolean;
  private _close = new BehaviorSubject<boolean>(false);
  close$ = this._close.asObservable();
  private _class = new BehaviorSubject<string>('success');
  class$ = this._class.asObservable();

  constructor(private element: ElementRef) {
  }

  ngOnInit() {
    this._class.subscribe(el => {
      this.element.nativeElement.children[0].classList.add(el);
    });
  }

  closeSnack() {
    this._close.next(true);
  }

  ngOnDestroy() {
    this.closeSnack();
  }
}
